export default __webpack_public_path__ + "static/images/document.3abd4368.svg";